<template>
  <BaseListHeader>
    <div class="flex -mx-3">
      <div class="flex-1 px-3">Name</div>
      <div class="flex-1 text-right px-3">Contacts</div>
      <div class="w-48" />
    </div>
  </BaseListHeader>
</template>

<script>
export default {
  name: 'ListHeader',
};
</script>
